import {React, useState, useRef} from 'react'
import '../components/GC_FAQ.css'



const GC_FAQ = (prop) => {



    const [openIndexes, setOpenIndexes] = useState([]);
    const contentRefs = useRef([]);

    const toggleItem = (index) => 
    {
    
        setOpenIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [index]
            );

        setTimeout(prop.onImgLoad, 700)
    };

  return (
    <section className="faq">
        <div className='container'>
            <div className="hh2 text-center mb-20">
                <div>Your Questions <span className="text-primary hh2">Answered</span></div>
               
            </div>


            <div className="accordion xl:w-1/2">
                {

                    prop.faq.map((item, index) => { 
                        const isOpen = openIndexes.includes(index);

                        return (
                            <div key={index} className="accordion-item">
                                <button
                                    className="accordion-header"
                                    onClick={() => toggleItem(index)}
                                    aria-expanded={isOpen}
                                >
                                    <span>{item.question}</span>
                                    <span className={`icon ${isOpen && "open"}`}></span>
                                </button>
                                
                                <div
                                    ref={(el) => (contentRefs.current[index] = el)}
                                    className="accordion-content"
                                    style={{
                                        height: isOpen
                                        ? `${contentRefs.current[index]?.scrollHeight}px`
                                        : "0px",
                                        overflow: "hidden",
                                        transition: "height 0.3s ease"
                                    }}
                                >
                                    
                                    <div className="opacity-60 mb-5">{item.answer}</div>  
                                </div>
                                
                            </div>
                        ) 
                    })
                }
            </div>
        
        </div>

    </section>
  )
}

export default GC_FAQ
